export type SolanaCluster = 'mainnet-beta' | 'devnet';

export type BlackBtcConfig = {
  mint: string;
  name: string;
  symbol: string;
  cluster: SolanaCluster;
  rpcUrl: string;
  backendUrl: string;
  thirdwebReady: boolean;
};

const localConfig: BlackBtcConfig = {
  mint: (import.meta.env.VITE_BLACK_BTC_MINT ?? '').trim(),
  name: (import.meta.env.VITE_BLACK_BTC_NAME ?? 'Black BTC').trim(),
  symbol: (import.meta.env.VITE_BLACK_BTC_SYMBOL ?? 'BLACKBTC').trim(),
  cluster: import.meta.env.VITE_SOLANA_CLUSTER === 'devnet' ? 'devnet' : 'mainnet-beta',
  rpcUrl: (import.meta.env.VITE_SOLANA_RPC_URL ?? 'https://api.mainnet-beta.solana.com').trim(),
  backendUrl: (import.meta.env.VITE_BLACK_BTC_BACKEND_URL ?? '').trim().replace(/\/$/, ''),
  thirdwebReady: false,
};

export function getLocalConfig(): BlackBtcConfig {
  return { ...localConfig };
}

export async function loadRuntimeConfig(): Promise<BlackBtcConfig> {
  if (!localConfig.backendUrl) return getLocalConfig();
  try {
    const response = await fetch(`${localConfig.backendUrl}/api/black-btc/config`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return getLocalConfig();
    const result = await response.json() as Partial<BlackBtcConfig> & { configured?: boolean };
    const cluster = result.cluster === 'devnet' ? 'devnet' : localConfig.cluster;
    const backendMint = result.configured === true && typeof result.mint === 'string'
      ? result.mint
      : undefined;
    const backendConfigured = Boolean(backendMint);
    return {
      ...localConfig,
      mint: backendMint ?? localConfig.mint,
      name: backendConfigured && typeof result.name === 'string' ? result.name : localConfig.name,
      symbol: backendConfigured && typeof result.symbol === 'string' ? result.symbol : localConfig.symbol,
      cluster,
      rpcUrl: cluster === localConfig.cluster
        ? localConfig.rpcUrl
        : cluster === 'devnet'
          ? 'https://api.devnet.solana.com'
          : 'https://api.mainnet-beta.solana.com',
      thirdwebReady: Boolean(result.thirdwebReady),
    };
  } catch {
    return getLocalConfig();
  }
}
